/**
 * Compacte links naar de centrale dienstpagina's (Schiphol, taxibus, tarieven,
 * boeken) onderaan stads- en Schipholpagina's. Gedeeld door NL en EN.
 */
const LINKS = {
  nl: {
    title: "Meer over onze taxiritten",
    items: [
      { href: "/taxi-schiphol", label: "Taxi naar Schiphol" },
      { href: "/taxibus-8-personen", label: "Taxibus tot 8 personen" },
      { href: "/taxi-tarieven", label: "Taxitarieven" },
      { href: "/boeken", label: "Taxi online boeken" },
    ],
  },
  en: {
    title: "More about our taxi rides",
    items: [
      { href: "/en/taxi-schiphol", label: "Taxi to Schiphol" },
      { href: "/en/minibus-taxi-8-passengers", label: "Minibus taxi up to 8 passengers" },
      { href: "/en/taxi-rates", label: "Taxi rates" },
      { href: "/en/book", label: "Book a taxi online" },
    ],
  },
} as const;

export function CityHubLinks({ locale = "nl" }: { locale?: "nl" | "en" }) {
  const c = LINKS[locale];
  return (
    <nav aria-label={c.title} className="mx-auto max-w-5xl px-4 pb-10">
      <h2 className="font-display text-lg font-bold">{c.title}</h2>
      <ul className="mt-3 flex flex-wrap gap-2">
        {c.items.map((l) => (
          <li key={l.href}>
            <a
              href={l.href}
              className="inline-flex rounded-full border px-3 py-1 text-sm text-foreground transition-colors hover:bg-accent"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
